import { useMemo } from 'react';
import { Filters } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

/**
 * Integrations Filters chrome (CT-4996): injects admin-studio copy into the
 * shared `@aimsos/ui` Filters (which stays English by default).
 */
export function IntegrationsFilters({ i18n: i18nProp, ...props }) {
  const { t } = useTranslation('admin-studio');
  const clearFilters = i18nProp?.clearFilters;
  const allFilters = i18nProp?.allFilters;
  const clearedAllAnnounce = i18nProp?.clearedAllAnnounce;
  const sortAsc = i18nProp?.sortAsc;
  const sortDesc = i18nProp?.sortDesc;

  const i18n = useMemo(
    () => ({
      clearFilters: clearFilters ?? t('common.filters.clearFilters'),
      allFilters: allFilters ?? t('common.filters.allFilters'),
      clearedAllAnnounce: clearedAllAnnounce ?? t('common.filters.clearedAll'),
      sortAsc: sortAsc ?? t('common.filters.sortAsc'),
      sortDesc: sortDesc ?? t('common.filters.sortDesc'),
    }),
    [t, clearFilters, allFilters, clearedAllAnnounce, sortAsc, sortDesc],
  );

  return <Filters {...props} i18n={i18n} />;
}
